import { createRequestTypes } from '../utils';

export const FETCH_SUBSTANCE_COS_ANNEXES = createRequestTypes('substanceCosAnnexe/FETCH_SUBSTANCE_COS_ANNEXE');
export const FETCH_SUBSTANCE_COS_ANNEXES_FOR_SUBSTANCE = createRequestTypes(
  'substanceCosAnnexe/FETCH_SUBSTANCE_COS_ANNEXES_FOR_SUBSTANCE',
);
export const DELETE_SUBSTANCE_COS_ANNEXE = createRequestTypes('substanceCosAnnexe/DELETE_SUBSTANCE_COS_ANNEXE');
export const SAVE_SUBSTANCE_COS_ANNEXE = createRequestTypes('substanceCosAnnexe/SAVE_SUBSTANCE_COS_ANNEXE');
export const LINK_COS_ANNEXE = createRequestTypes('substanceCosAnnexe/LINK_COS_ANNEXE');
